import { useContext, useState } from 'react'
import { AgxToast } from '@urbanx/agx-ui-components'
import { AuthContext } from '@urbanx/agx.auth.client'
import { MenuTitles, Pages } from 'constants/menu'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { ContentLayout, PageLayout } from 'layout'
import { AgxToastState } from 'types/commonTypes'
import VendorDetailsSection from './VendorDetailsSection'
import useVendorDetailsSectionState from './useVendorDetailsSectionState'
import PropertyInformationSubPage from '../PropertyInformationSubPage'
import { cleanFullAddress } from '@urbanx/agx.ui-components2'

const VendorDetailsPage = () => {
  const { userAccount } = useContext(AuthContext)
  const { agency } = useSelectedAgency()
  const { campaign } = useSelectedCampaign()
  const [toastState, updateToastState] = useState<AgxToastState>({
    color: 'success',
    message: '',
    open: false,
  })
  const {
    vendorDetails,
    setVendorDetails,
    solicitorDetails,
    setSolicitorDetails,
    hasUnsavedChanges,
    saveState,
    handleSaveChanges,
    isPending,
  } = useVendorDetailsSectionState({
    campaignId: campaign?.campaignId,
    updateToastState,
  })

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.PROPERTY_INFORMATION}
        isCampaigns={true}
      >
        <AgxToast selector="#agxToast" toastState={toastState} />
        {!isPending && (
          <PropertyInformationSubPage
            currentPage={Pages.PROPERTY_INFORMATION_VENDOR_DETAILS}
            isLoading={isPending}
            saveState={saveState}
            hasUnsavedChanges={hasUnsavedChanges}
            onSave={handleSaveChanges}
            saveButtonId="vendorDetailsSaveChanges"
            saveButtonTestId="btn-vendorDetailsSaveChanges"
            showChildren={!isPending}
          >
            <VendorDetailsSection
              campaign={campaign}
              vendorDetails={vendorDetails}
              setVendorDetails={setVendorDetails}
              solicitorDetails={solicitorDetails}
              setSolicitorDetails={setSolicitorDetails}
              hasUnsavedChanges={hasUnsavedChanges}
            />
          </PropertyInformationSubPage>
        )}
      </ContentLayout>
    </PageLayout>
  )
}

export default VendorDetailsPage
